export const companyInviteStatusValues = ['pending', 'revoked', 'accepted'] as const;
export type CompanyInviteStatus = (typeof companyInviteStatusValues)[number];

export interface CompanyInviteDto {
  id: string; // UUID
  companyId: string; // UUID
  email: string;
  status: CompanyInviteStatus;
  pendingRoleIds?: string[]; // UUID[]
  expiresAt: string; // ISO timestamp
  createdAt: string; // ISO timestamp
  createdByUserId: string; // UUID
}

export interface CreateCompanyInviteRequest {
  companyId: string; // UUID
  email: string;
  pendingRoleIds: string[]; // UUID[]
  expiresInDays?: number;
}

export interface CreateCompanyInviteResponse {
  invite: CompanyInviteDto;
  inviteToken: string;
}

export interface ListCompanyInvitesRequest {
  companyId: string; // UUID
}

export interface ListCompanyInvitesResponse {
  items: CompanyInviteDto[];
}

export interface RevokeCompanyInviteRequest {
  companyId: string; // UUID
  inviteId: string; // UUID
}

export interface RevokeCompanyInviteResponse {
  invite: CompanyInviteDto;
}

